export interface ICurrentUser {
  address: string;
  displayAddress: string;
  chainType: string;
  authType: string;
  email: string;
  emailNotification: boolean;
  nickName: string;
  telegram: string;
  telegramNickName: string;
  telegramNotification: boolean;
  ens?: string;
  role?: string;
  walletAddress?: string;
  name?: string;
  identityPublicKey: string; // Identity 公钥
  identitySeed: string; // Identity Seed Message
  enableIdentity: boolean; // 是否启用 Identity
  identityInitialized: boolean; // 是否已经初始化 Identity
  singpassUserId?: string;
  singpassUserName?: string;
  uaepassUserId?: string;
  uaepassUserName?: string;
  encryptedPKByPassword?: string;
  encryptedPKByWallet?: string;
  roles?: string[];
  chainId?: number;
  eKyc?: 'singpass' | 'uaepass';
}

export interface IOption {
  label: string;
  value: string;
}
export enum InputType {
  text = 'text',
  number = 'number',
  date = 'date',
  textarea = 'textarea'
}
export interface IField {
  id: string;
  label: string;
  type: string;
  required: boolean;
  custom: any;
  value: string;
  color: string;
  inputType: InputType;
}

export enum USER_ROLE_ENUM {
  TEMPLATEADMIN = 'template_admin'
}

export interface IResponseWithPagination<T> {
  rows: T[];
  page: number;
  size: number;
  total: number;
}
